export const QUESTIONS = [
  {
    question: 'あなたの髪の色は？',
    group: 'season',
    answers: [
      {
        text: '黄みのライトブラウンでやわらかい。',
        value: 'A',
        colors: ['#925B22', '#713A01'],
      },
      {
        text: '赤みのローズブラウン。またはソフトなブラックでサラサラ。',
        value: 'B',
        colors: ['#65362C', '#3F3F3F'],
      },
      {
        text: '黄みのダークブラウン。または緑みのマットブラウンでコシがある。',
        value: 'C',
        colors: ['#5D3F27', '#716246'],
      },
      {
        text: 'ツヤのあるブラック。1本1本が太くてしっかりしている。',
        value: 'D',
        colors: ['#010000'],
      },
    ],
  },
  {
    question: 'あなたの肌の色は？',
    group: 'season',
    answers: [
      {
        text: '明るいアイボリー。ツヤがあって皮膚は薄い感じ。',
        value: 'A',
        colors: ['#FEEFCE'],
      },
      {
        text: '色白でピンク系。なめらかな質感で頬に赤みが出やすい。',
        value: 'B',
        colors: ['#FCE4D7'],
      },
      {
        text: '暗めのオークル系。頬に色味がなくマットな質感。くすみやすい方も。',
        value: 'C',
        colors: ['#FEE19F'],
      },
      {
        text: 'ピンク系で色白。又は濃い目の肌色で皮膚は厚め。',
        value: 'D',
        colors: ['#FBE1CA', '#F8C59A'],
      },
    ],
  },
  {
    question: 'あなたの瞳の色は？',
    group: 'season',
    answers: [
      {
        text: 'キラキラとした黄みのライトブラウン～ダークブラウン',
        value: 'A',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_3-A.png?v=1750293906',
      },
      {
        text: '赤みのダークブラウン～ソフトなブラック。ソフトでやさしい印象。',
        value: 'B',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_3-B.png?v=1750293906',
      },
      {
        text: '黄みのダークブラウンで落ち着いた印象。緑みを感じる方も。',
        value: 'C',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_3-C.png?v=1750293906',
      },
      {
        text: 'シャープなブラック。白目と黒目のコントラストが強く目力がある。切れ長の方も。',
        value: 'D',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_3-D.png?v=1750293906',
      },
    ],
  },
  {
    question: '人からよく言われるあなたのイメージは？',
    group: 'season',
    answers: [
      {
        text: 'キュート、フレッシュ、カジュアル、アクティブ',
        value: 'A',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_4-A.png?v=1750293906',
      },
      {
        text: '上品、やさしい、さわやか、やわらかい',
        value: 'B',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_4-B.png?v=1750293906',
      },
      {
        text: 'シック、こなれた、ゴージャス、落ち着いた',
        value: 'C',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_4-C.png?v=1750293906',
      },
      {
        text: 'モダン、シャープ、スタイリッシュ、クール',
        value: 'D',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_4-D.png?v=1750293906',
      },
    ],
  },
  {
    question: 'ワードローブに多い、得意なベーシックカラーは？',
    group: 'season',
    answers: [
      {
        text: 'ベージュやキャメルが多い。顔色が明るく血色よく見える。',
        value: 'A',
        colors: ['#FBE7C2', '#DA9762'],
      },
      {
        text: 'ブルーグレーやネイビーが多い。肌に透明感が出て上品に見える。',
        value: 'B',
        colors: ['#778899', '#223A70'],
      },
      {
        text: 'ダークブラウンやカーキ。地味にならずにこなれて見える。',
        value: 'C',
        colors: ['#5D3F27', '#6E7955'],
      },
      {
        text: 'ブラック。着ても暗くならず、小顔＆シャープに見える。',
        value: 'D',
        colors: ['#010000', '#9FA0A0'],
      },
    ],
  },
  {
    question: '人前で話すのは',
    group: 'personality',
    answers: [
      {
        text: 'わりと得意な方だ',
        value: 'A',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_6-A.png?v=1750293906',
      },
      {
        text: 'できれば避けたい',
        value: 'B',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_6-B.png?v=1750293906',
      },
    ],
  },
  {
    question: '休みの日の過ごし方は',
    group: 'personality',
    answers: [
      {
        text: '誰かと話題のスポットに出かけたい',
        value: 'A',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_7-A.png?v=1750293906',
      },
      {
        text: '家の中で1人でのんびり',
        value: 'B',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_7-B.png?v=1750293906',
      },
    ],
  },
  {
    question: '新しいことを始めるときは',
    group: 'personality',
    answers: [
      {
        text: '思い立ったらまずやってみる',
        value: 'A',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_8-A.png?v=1750293906',
      },
      {
        text: '慎重に考えてから行動に移す',
        value: 'B',
        image:
          'https://cdn.shopify.com/s/files/1/0132/7936/3136/files/color-analysis_8-B.png?v=1750293906',
      },
    ],
  },
]
export const RESULT_SLUGS = {
  AA: 'spring-lively',
  AB: 'spring-calm',
  BA: 'summer-lively',
  BB: 'summer-calm',
  CA: 'autumn-lively',
  CB: 'autumn-calm',
  DA: 'winter-lively',
  DB: 'winter-calm',
}
